export const nameEnquiry = (setState, state) => {
  setState({
    ...state,
    active1: true,
    active2: false,
    active3: false,
    active4: false,
    active5: false,
    active6: false,
    active7: false,
    active8: false,
    active9: false,
    active10: false,
  });
};

export const mandateAdvice = (setState, state) => {
  setState({
    ...state,
    active1: false,
    active2: true,
    active3: false,
    active4: false,
    active5: false,
    active6: false,
    active7: false,
    active8: false,
    active9: false,
    active10: false,
  });
};

export const balanceEnquiry = (setState, state) => {
  setState({
    ...state,
    active1: false,
    active2: false,
    active3: true,
    active4: false,
    active5: false,
    active6: false,
    active7: false,
    active8: false,
    active9: false,
    active10: false,
  });
};

export const fundTransferDirectCredit = (setState, state) => {
  setState({
    ...state,
    active1: false,
    active2: false,
    active3: false,
    active4: true,
    active5: false,
    active6: false,
    active7: false,
    active8: false,
    active9: false,
    active10: false,
  });
};

export const fundTransferAdviceDirectCredit = (setState, state) => {
  setState({
    ...state,
    active1: false,
    active2: false,
    active3: false,
    active4: false,
    active5: true,
    active6: false,
    active7: false,
    active8: false,
    active9: false,
    active10: false,
  });
};

export const fundTransferDirectDebit = (setState, state) => {
  setState({
    ...state,
    active1: false,
    active2: false,
    active3: false,
    active4: false,
    active5: false,
    active6: true,
    active7: false,
    active8: false,
    active9: false,
    active10: false,
  });
};

export const fundTransferAdviceDirectDebit = (setState, state) => {
  setState({
    ...state,
    active1: false,
    active2: false,
    active3: false,
    active4: false,
    active5: false,
    active6: false,
    active7: true,
    active8: false,
    active9: false,
    active10: false,
  });
};

export const amountBlock = (setState, state) => {
  setState({
    ...state,
    active1: false,
    active2: false,
    active3: false,
    active4: false,
    active5: false,
    active6: false,
    active7: false,
    active8: true,
    active9: false,
    active10: false,
  });
};

export const accountBlock = (setState, state) => {
  setState({
    ...state,
    active1: false,
    active2: false,
    active3: false,
    active4: false,
    active5: false,
    active6: false,
    active7: false,
    active8: false,
    active9: true,
    active10: false,
  });
};

export const financialInstitutionList = (setState, state) => {
  setState({
    ...state,
    active1: false,
    active2: false,
    active3: false,
    active4: false,
    active5: false,
    active6: false,
    active7: false,
    active8: false,
    active9: false,
    active10: true,
  });
};

export default {
  nameEnquiry,
  mandateAdvice,
  balanceEnquiry,
  fundTransferDirectCredit,
  fundTransferAdviceDirectCredit,
  fundTransferDirectDebit,
  fundTransferAdviceDirectDebit,
  amountBlock,
  accountBlock,
  financialInstitutionList,
};
